import bg from 'assets/img/analyzers-bg.png';
import { Background, Card } from '../Shared';
import RiskReturn from './RiskReturn';
import RiskRatios from './RiskRatios';
import ValueAtRisk from './ValueAtRisk';
import BetaCorrelation from './BetaCorrelation';

import betaandcorrelation_ from 'assets/img/landing-icons/ct-beta-and-correlation.png';
import riskandreturn_ from 'assets/img/landing-icons/ct-risk-and-return.png';
import riskratios_ from 'assets/img/landing-icons/ct-risk-ratios.png';
import valueatrisk_ from 'assets/img/landing-icons/ct-value-at-risk.png';

import HorizontalLanding from 'components/HorizontalLanding';

export const meta = {
  path: '/ct',
  title: 'Charts & Trends',
  component: Landing,
  items: [
    {
      path: '/risk-return',
      title: 'Risk & Return',
      component: RiskReturn,
      description:
        'Dynamic visualization of risk and return trend for any asset or portfolio over a series of rolling time windows.',
      imgSrc: riskandreturn_,
      permission: 'ct-risk-return',
    },
    {
      path: '/risk-ratios',
      title: 'Risk Ratios',
      component: RiskRatios,
      description:
        'Dynamic visualization of risk-adjusted returns for any asset or portfolio over a series of rolling time windows.',
      imgSrc: riskratios_,
      permission: 'ct-risk-ratios',
    },
    {
      path: '/value-at-risk',
      title: 'Value at Risk',
      component: ValueAtRisk,
      description:
        'Dynamic visualization of VaR trend over varying types, confidence intervals, and rolling time windows.',
      imgSrc: valueatrisk_,
      permission: 'ct-value-at-risk',
    },
    {
      path: '/beta-correlation',
      title: 'Beta & Correlation',
      component: BetaCorrelation,
      description:
        'Dynamic visualization of an asset’s beta and correlation trend versus a specified benchmark, asset or risk factor.',
      imgSrc: betaandcorrelation_,
      permission: 'ct-beta-correlation',
    },
  ],
};

export default function Landing({ session }) {
  return <HorizontalLanding meta={meta} session={session} />;
}
